export const GoodFaithEstimateRoutes = [
    {
        "url": "/gfe-incidents",
        "name": "appLayout.schedule.clock-time.gfe-incidents",
        "showGlobalSearch": true,
        "type": "frontend",
        "loginRequired": true,
        "views": {
            'clock-time-body': {
                "component": "goodFaithEstimateIncidents"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/good-faith-estimate/good-faith-estimate.downgrade.module");
                }
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ['good-faith-estimate']
        },
    }
];
//# sourceMappingURL=good-faith-estimate.routes.js.map